import { useCallback } from 'react';
import { db } from '../data/storage';
import { cacheManager } from '../data/cacheManager';
import type { Feeding } from '../data/types';

export function useFeedings() {
    // Optimistic add feeding
    const addFeeding = useCallback(async (feeding: Feeding) => {
        const syncId = `feeding-add-${feeding.id}`;

        // 1. Update cache immediately (optimistic)
        cacheManager.updateCacheOptimistically('feeding', 'add', feeding);

        // 2. Mark as pending sync
        cacheManager.addPendingSync({
            id: syncId,
            type: 'feeding',
            operation: 'add',
            data: feeding,
        });

        // 3. Sync to IndexedDB (background)
        try {
            await db.addFeeding(feeding);
            cacheManager.removePendingSync(syncId);
        } catch (error) {
            console.error('Failed to add feeding:', error);
            // Will retry on next app load
        }
    }, []);

    return {
        addFeeding,
    };
}